import { render } from "./AppHeader.vue?vue&type=template&id=bfaa8092&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=bfaa8092&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bfaa8092"

export default script